<template>
	<div class="technical-requirements">
		<div class="head-before-table">
			<h3>Технические требования</h3>
		</div>

		<div class="tab">
			<div :class="{ active: activeField === 'banners' }"
				 class="item banners"
				 @click="activeField = 'banners'">
				Баннеры
			</div>
			<div :class="{ active: activeField === 'video' }"
				 class="item video"
				 @click="activeField = 'video'">
				Видео
			</div>
			<div :class="{ active: activeField === 'youtube' }"
				 class="item youtube"
				 @click="activeField = 'youtube'">
				YouTube
			</div>
			<div :class="{ active: activeField === 'audio' }"
				 class="item audio"
				 @click="activeField = 'audio'">
				Аудио
			</div>
		</div>
		<div v-show="activeField === 'banners'"
			 class="tab">
			<div :class="{ active: banners === 'images' }"
				 class="item images"
				 @click="banners = 'images'">
				Изображения
			</div>
			<div :class="{ active: banners === 'html5' }"
				 class="item html5"
				 @click="banners = 'html5'">
				HTML5
			</div>
		</div>

		<div class="main-block">

			<div v-show="activeField === 'banners' && banners === 'images'"
				 class="info images">
				<h4>Распространенные размеры баннеров:</h4>

				<div class="list">
					<h6>Квадрат и прямоугольник:</h6>
					<ul>
						<li>240×400</li>
						<li>250×250</li>
						<li>300×250</li>
						<li>336×280</li>
					</ul>
				</div>
				<div class="list">
					<h6>Небоскреб:</h6>
					<ul>
						<li>120×600</li>
						<li>160×600</li>
						<li>300×600</li>
					</ul>
				</div>
				<div class="list">
					<h6>Полноразмерный баннер:</h6>
					<ul>
						<li>468×60</li>
						<li>728×90</li>
					</ul>
				</div>
				<div class="list">
					<h6>Мобильное устройство:</h6>
					<ul>
						<li>300×50</li>
						<li>320×50</li>
						<li>320×100</li>
						<li>320×480</li>
					</ul>
				</div>

				<p>
					<span class="bold">Итого:</span> 120×600, 160×600, 240×400, 250×250, 300×50, 300×250, 300×600, 320×50, 320×100, 320×480, 336×280,
					468×60, 728×90.
				</p>
				<h4>Требования к объектам</h4>
				<table>
					<tbody>
						<tr>
							<td>Типы файлов</td>
							<td>JPG, JPEG, GIF и PNG.</td>
						</tr>
						<tr>
							<td>Параметры</td>
							<td>Максимум 4096×4096 пикселей.</td>
						</tr>
						<tr>
							<td>Размер файла</td>
							<td>Размер файла не должен превышать 10 МБ.</td>
						</tr>
						<tr>
							<td>URL целевой страницы</td>
							<td>Обязательно.</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div v-show="activeField === 'banners' && banners === 'html5'"
				 class="info html5">
				<h4>Распространенные размеры баннеров:</h4>

				<div class="list">
					<h6>Квадрат и прямоугольник:</h6>
					<ul>
						<li>240×400</li>
						<li>250×250</li>
						<li>300×250</li>
						<li>336×280</li>
					</ul>
				</div>
				<div class="list">
					<h6>Небоскреб:</h6>
					<ul>
						<li>120×600</li>
						<li>160×600</li>
						<li>300×600</li>
					</ul>
				</div>
				<div class="list">
					<h6>Полноразмерный баннер:</h6>
					<ul>
						<li>468×60</li>
						<li>728×90</li>
					</ul>
				</div>
				<div class="list">
					<h6>Мобильное устройство:</h6>
					<ul>
						<li>300×50</li>
						<li>320×50</li>
						<li>320×100</li>
						<li>320×480</li>
					</ul>
				</div>

				<p>
					<span class="bold">Итого:</span> 120×600, 160×600, 240×400, 250×250, 300×50, 300×250, 300×600, 320×50, 320×100, 320×480, 336×280,
					468×60, 728×90.
				</p>

				<h4>Требования к объектам</h4>

				<table>
					<tbody>

						<tr>
							<td>Конверсии по кликам</td>
							<td>Медийные креативы на основе HTML5 должны иметь теги кликов, чтобы перенаправлять пользователей на целевую страницу.
								Серверы объявлений должны корректно обрабатывать теги кликов. Не используйте минимизатор кода для тегов кликов.
								При нажатии на объявление целевая страница должна открываться в новой вкладке или в новом окне.
							</td>
						</tr>
						<tr>
							<td>Анимация</td>
							<td>Анимация в объявлении должна длиться не более 30 секунд.</td>
						</tr>
						<tr>
							<td>Автовоспроизведение</td>
							<td>Запрещены объявления с автовоспроизведением аудио.
								Можно использовать автоматический запуск видео, но при этом звук должен быть отключен.
							</td>
						</tr>
						<tr>
							<td>Всплывающие окна</td>
							<td>Запрещены объявления со всплывающими окнами или опросами.</td>
						</tr>
						<tr>
							<td>Файлы cookie</td>
							<td>Одному креативу можно назначить не более 25 файлов cookie.</td>
						</tr>
						<tr>
							<td>HTTP-вызовы</td>
							<td>HTTP-вызов – это любой внешний файл или ресурс, загружаемый вашим объявлением (например, сторонний счетчик показов).
								Одно
								объявление может выполнять не более 100 вызовов.</td>
						</tr>
					</tbody>
				</table>

				<h4>Поддерживаемые типы файлов</h4>

				<p>Креативы на основе HTML5 <span class="bold">должны быть сжаты в ZIP-файл</span>. ZIP-архив с HTML5-объектами может включать типы
					файлов, перечисленные в таблице
					ниже.</p>

				<table>
					<tbody>

						<tr>
							<td>HTML-файлы, а также файлы стилей и скриптов</td>
							<td>.html, .css, .js
							</td>
						</tr>
						<tr>
							<td>Изображения</td>
							<td>.jpg, .jpeg, .gif, .png, .svg</td>
						</tr>
						<tr>
							<td>Шрифт</td>
							<td>.dfont, .eot, .otf, .tte, .ttf, .woff, .woff2
							</td>
						</tr>
					</tbody>
				</table>

				<h4>Следуйте рекомендациям в отношении размеров</h4>
				<p>Используйте метатег size, чтобы задать размеры вашего креатива:</p>
				<pre class="hljs"
					 style="display: block; overflow-x: auto; padding: 0.5em; background: rgb(240, 240, 240); color: rgb(68, 68, 68);">
&lt;meta name="ad.size" content="width=[x],height=[y]"&gt;
</pre>

				<p>У креативов HTML5 могут быть только фиксированные размеры, например 300×250, 400×400, 728×90. Динамические размеры не
					поддерживаются.</p>

				<p class="example">Пример:</p>
				<pre class="hljs"
					 style="display: block; overflow-x: auto; padding: 0.5em; background: rgb(240, 240, 240); color: rgb(68, 68, 68);">
&lt;meta name="ad.size" content="width=300,height=250"&gt;
</pre>

				<p>В HTML-файлах креативов значения свойств <code style="background: rgb(240, 240, 240); padding: 0.2em;">minWidth</code> и <code
						  style="background: rgb(240, 240, 240); padding: 0.2em;">minHeight</code> параметра <code
						  style="background: rgb(240, 240, 240); padding: 0.2em;">creativeProperties</code> должны отличаться от нуля.</p>

				<p>Если указать следующие значения:</p>
				<pre class="hljs"
					 style="display: block; overflow-x: auto; padding: 0.5em; background: rgb(240, 240, 240); color: rgb(68, 68, 68);">
"creativeProperties": {
  "minWidth": 0,
  "minHeight": 0,
  "maxWidth": 0,
  "maxHeight": 0
}
</pre>
				<p>Это приведет к ошибке.</p>

				<h4>Следуйте рекомендациям по работе с тегами кликов и URL перехода по клику</h4>

				<ul class="ul-list">
					<li>Переход – это любая область, при нажатии на которую выполняется переадресация на целевую страницу. Теги кликов определяют URL
						перехода
						по клику для каждого перехода в креативе HTML5.</li>

					<li>Когда пользователь нажимает на переход, креатив запрашивает соответствующий URL перехода по клику.</li>

					<li>В зависимости от ваших целей и типа креатива этот URL можно задать в креативе или объявлении. Если сделать это и в креативе, и
						в
						объявлении, приоритет будет иметь настройка на уровне объявления.</li>

					<li>Необходимо вставить тег клика в раздел
						<pre class="hljs"
							 style="display: inline; overflow-x: auto; padding: 0.5em; background: rgb(240, 240, 240); color: rgb(68, 68, 68);"><span class="hljs-variable" style="color: rgb(188, 96, 96);">&lt;head&gt;</span></pre>
						HTML-документа
					</li>

				</ul>

				<p>Используйте переменную</p>
				<pre class="hljs"
					 style="display: inline; overflow-x: auto; padding: 0.5em; background: rgb(240, 240, 240); color: rgb(68, 68, 68);">clickTag</pre>
				<p>в качестве целевого ресурса в креативе.</p>

				<p class="example">Пример:</p>
				<pre class="hljs"
					 style="display: block; align-self: center; overflow-x: auto; padding: 0.5em; text-align: start; background: rgb(240, 240, 240); color: rgb(68, 68, 68);">
&lt;head&gt;
  &lt;meta name="ad.size" content="width=300,height=250"&gt;
  &lt;script type="text/javascript"&gt;
      var clickTag = "http://www.google.com";
  &lt;/script&gt;
&lt;/head&gt;
</pre>

				<p>Чтобы сервер объявлений мог легко прочитать тег кликов, не применяйте в нем минификацию и обфускацию кода. Однако она допустима в
					остальном коде и других файлах.</p>
			</div>
			<div v-show="activeField === 'video'"
				 class="info video">
				<h4>Требования к объектам</h4>

				<div class="list">
					<h6>Горизонтальное расположение:</h6>
					<ul>
						<li>1280×720</li>
						<li>1920×1080</li>
						<li>1440×1080</li>
					</ul>
				</div>
				<div class="list">
					<h6>Вертикальное расположение:</h6>
					<ul>
						<li>720×1280</li>
						<li>1080×1920</li>
						<li>1080×1440</li>
					</ul>
				</div>
				<div class="list">
					<h6>Квадрат:</h6>
					<ul>
						<li>720×720</li>
						<li>1080×1080</li>
						<li>1920×1920</li>
					</ul>
				</div>
				<div class="list">
					<h6>Соотношение сторон:</h6>
					<ul>
						<li>
							<h6>Горизонтальное расположение:</h6>
							<ul>
								<li>
									16:9 (например, 640×360)
								</li>
								<li>
									4:3 (например, 640×480)
								</li>
							</ul>
						</li>
						<li>
							<h6>Вертикальная ориентация:</h6>
							<ul>
								<li>
									9:16 (например, 360×640)
								</li>
								<li>
									3:4 (например, 480×640)
								</li>
							</ul>
						</li>
					</ul>
				</div>

				<h4>Требования к объектам</h4>
				<table>
					<tbody>

						<tr>
							<td>Типы файлов</td>
							<td>.avi, .mov, .mp4, .m4v, .mpeg, .mpg, .webm, .wmv</td>
						</tr>
						<tr>
							<td>Размер файла</td>
							<td>Можно размещать видеокреативы размером до 100 МБ, однако для перекодированных файлов установлено ограничение в 10 МБ.
								Всегда загружайте исходный файл самого высокого качества, чтобы наш сервис мог преобразовать его в максимально
								возможное
								количество форматов.</td>
						</tr>
						<tr>
							<td>Название</td>
							<td>В названии файла должно быть не более 50 символов.
								Поддерживаются только символы ASCII.
							</td>
						</tr>
						<tr>
							<td>Длительность</td>
							<td>
								<h6>Поддерживаются креативы следующей длительности:</h6>
								<ul class="ul-list">
									<li>менее 15 секунд</li>
									<li>15 секунд</li>
									<li>20 секунд</li>
									<li>30 секунд</li>
									<li>60 секунд</li>
									<li>90 секунд или более</li>
								</ul>
								<p>Видеообъявление будет корректно воспроизводиться и в том случае, если его продолжительность меньше величины,
									которую
									допускает
									инвентарь.</p>
								<p>Например, если ваш ролик имеет длину 22 секунды, он может быть показан в инвентаре с ограничением в 30 секунд. Если
									сравнивать с самым длинным видео в креативе, все остальные видео в нем не могут быть короче более чем на 10%.</p>
							</td>
						</tr>
						<tr>
							<td>URL целевой страницы</td>
							<td>Для всех креативов должен быть задан URL целевой страницы. Обратите внимание, что страница будет открываться в новом
								окне.
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-show="activeField === 'youtube'"
				 class="info youtube">

				<h4>Требования к объектам</h4>

				<p>Чтобы можно было обрабатывать ваши ролики, в их параметрах доступа на YouTube выберите вариант "Открытый доступ" или
					"Доступ по ссылке". Нельзя использовать видео с ограниченным доступом, а также ролики, которые находятся на сторонних серверах.
				</p>
				<table class="youtube">
					<tbody>

						<tr>
							<td>Формат объявления</td>
							<td>Где показываются объявления</td>
							<td>Тип видео</td>
						</tr>
						<tr>
							<td>Bumper</td>
							<td>Видео YouTube Видеоролики, игры, приложения партнеров</td>
							<td>Видео YouTube (до 6 сек.)</td>
						</tr>
						<tr>
							<td>Non-skippable ads (Объявления без возможности пропуска)</td>
							<td>Видео YouTube Видеоролики, игры, приложения партнеров</td>
							<td>Видео YouTube (6–15 сек.)</td>
						</tr>
						<tr>
							<td>In-stream ad</td>
							<td>Видео YouTube Видеоролики, игры, приложения партнеров</td>
							<td>Видео YouTube (рекомендуемая длительность – менее 3 мин.)</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-show="activeField === 'audio'"
				 class="info audio">

				<h4>Требования к объектам</h4>

				<table>
					<tbody>

						<tr>
							<td>Типы файлов</td>
							<td>OGG, MP3</td>
						</tr>
						<tr>
							<td>Размер файла</td>
							<td>Можно размещать файлы объемом до 10 МБ. Чтобы обеспечить поддержку креатива на разных биржах, загрузите исходный файл
								с
								максимально возможным качеством.</td>
						</tr>
						<tr>
							<td>Длительность</td>
							<td>В нашем сервисе поддерживаются аудиокреативы разной продолжительности. Мы рекомендуем использовать файлы длительностью
								от
								15
								до 30 сек. Они подходят для большей части инвентаря.</td>
						</tr>
						<tr>
							<td>URL целевой страницы</td>
							<td>Обязательно.</td>
						</tr>
					</tbody>
				</table>

				<h4>Рекомендации в отношении аудиокреативов</h4>

				<div class="audio-recomendations">
					<h6>Следите за тоном и темпом</h6>
					<ul>
						<li>Оптимальный темп для 30-секундного объявления: 55–75 слов.</li>
						<li>Оптимальный темп для 15-секундного объявления: 40 слов.</li>
					</ul>
				</div>
				<div class="audio-recomendations">
					<h6>Взаимодействуйте с аудиторией</h6>
					<ul>
						<li>Дружелюбное обращение обеспечивает плавный переход от развлекательного контента к рекламе.</li>
					</ul>
				</div>
				<div class="audio-recomendations">
					<h6>Добавляйте призывы к действию</h6>
					<ul>
						<li>Позвольте слушателям проявить активность. Прямой призыв к действию повышает CTR.</li>
					</ul>
				</div>
				<div class="audio-recomendations">
					<h6>Рассказывайте историю</h6>
					<ul>
						<li>Используйте ненавязчивые эффекты и звуки природы, которые создают определенные образы.</li>
					</ul>
				</div>
				<div class="audio-recomendations">
					<h6>Создавайте разные варианты объявления</h6>
					<ul>
						<li>Придумывайте версии креатива с учетом предпочтений аудитории.</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TechnicalRequirements",
	data() {
		return {
			activeField: "banners",
			banners: "images",
		};
	},
}
</script>